import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '@src/core/hooks';
import { setStepCheckout } from '@src/stores/checkout';
import { useWidgetId } from '@src/core/IdProvider';
import ResetPasswordForm from './ResetPasswordForm';
import ChangePasswordForm from './ChangePasswordForm';

type ForgotPasswordFormProps = {
  email: string;
  onCancel?: () => void;
};

const ForgotPasswordForm = (props: ForgotPasswordFormProps) => {
  const { email, onCancel = () => {} } = props;

  const id = useWidgetId();
  const dispatch = useAppDispatch();
  const [mode, setMode] = useState<'reset' | 'change'>('reset');

  useEffect(() => {
    dispatch(setStepCheckout({ id, value: '' }));
  });

  const onPasswordResetSuccess = () => {
    setMode('change');
  };

  return (
    <div>
      {(() => {
        switch (mode) {
          case 'reset':
            return <ResetPasswordForm email={email} onSuccess={onPasswordResetSuccess} onCancel={onCancel} />;
          case 'change':
            return <ChangePasswordForm email={email} onCancel={onCancel} />;
          default:
            return null;
        }
      })()}
    </div>
  );
};

export default ForgotPasswordForm;
